import { render, staticRenderFns } from "./money-requests.vue?vue&type=template&id=2b98c8a5&"
import script from "./money-requests.vue?vue&type=script&lang=js&"
export * from "./money-requests.vue?vue&type=script&lang=js&"
import style0 from "./money-requests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports